/**
 * Enum representing the color context for a component, such as a link or button.
 */
export enum Context {
  None = '',
  Dark = 'dark',
  Light = 'light',
  Primary = 'primary',
  Secondary = 'secondary',
  White = 'white'
}
